module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C111"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "C114"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_1__Revolution#page_1"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_2__Love_s_Dimensions#page_16"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Love’s Dimensions")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_3__Human_Natures#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Human Natures")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_4__Little_Heart_Shaped_Pills#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Little Heart-Shaped Pills")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_5__Good_Enough_Marriages#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Good-Enough Marriages")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_6__Ecstasy_as_Therapy#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Ecstasy as Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_7__Evolved_Fragility#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Evolved Fragility")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_8__Wonder_Hormone#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Wonder Hormone")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_9__Anti_love_Drugs#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" Anti-love Drugs")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_10__Chemical_Breakups#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10.")]), _vm._v(" Chemical Breakups")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_11__Avoiding_Disaster#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" Avoiding Disaster")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_12__Choosing_Love#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12.")]), _vm._v(" Choosing Love")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Epilogue__Pharmacopeia#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Pharmacopeia")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Acknowledgments#page_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#page_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Index#page_255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_About_the_Authors#page_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 72
// module chunks = 0